import React from 'react';
import Plan from '@app/components/Plans/Plan';

export default function PlanDisplayPlanRenderer({ plan, theme }) {
    return <Plan className={`h-100 ${plan?.token ? '' : 'plan-unloaded'}`} data={plan} theme={theme} />;
}
